<ap-header></ap-header>
<div class="ap-padding-top-lt-md-2 ap-padding-gt-sm-6 ap-margin-gt-sm-6">
    <div class="ap-flex ap-padding-gt-sm-6 canvas">
        <div class="ap-flex-basis-gt-sm-25"></div>
        <div class="ap-flex-gt-sm-50 ap-flex-lt-md-fill">
            <ap-panel class="ap-margin-6" type="tertiary">
                <div ap-panel-body>
                    <h1>{{ 'huismap.title' | apContent }}</h1>

                    <p>{{ 'huismap.intro' | apContent }}</p>

                    <ap-notification status="tip">{{ 'huismap.intro-info' | apContent }}</ap-notification>

                    <ap-button-link [href]="'huismap.login-url' | apContent">
                        {{ 'huismap.login-button' | apContent }}
                    </ap-button-link>

                    <ap-button-link variant="secondary" [href]="'huismap.prospect-digicode.username-forgot-url' | apContent">
                        {{ 'huismap.forgot-username-button' | apContent }}
                    </ap-button-link>
                </div>
            </ap-panel>
        </div>
        <div class="ap-flex-basis-gt-sm-25"></div>
    </div>
</div>
